import { useCallback, useState } from 'react'

export const useLaneEditor = (propLane) => {
  const [isVisible, setIsVisible] = useState(false)
  const toggleEditor = useCallback(() => setIsVisible((v) => !v), [])
  const closeEditor = useCallback(() => setIsVisible(false), [])
  return { isVisible, toggleEditor, closeEditor, propLane }
}
